/* eslint-disable react/no-danger */

"use client"

import clsx from "clsx"
import React, { useState, useEffect } from "react"

import useWistiaScripts from "@/hooks/useWistiaScripts"

interface WistiaPlayerProps {
  title?: string
  videoId: string
  className?: string
}

export default function WistiaPlayer({
  videoId,
  title,
  className,
}: WistiaPlayerProps) {
  const [isClient, setIsClient] = useState(false)
  const scriptsLoaded = useWistiaScripts()

  useEffect(() => {
    setIsClient(true)
  }, [])

  // Show loading state while scripts are loading
  if (!isClient || !scriptsLoaded) {
    // TODO: add loading state
    return null
  }

  return (
    <div
      className={clsx(
        "relative overflow-hidden aspect-video rounded-lg",
        className,
      )}
    >
      <iframe
        src={`https://fast.wistia.net/embed/iframe/${videoId}?web_component=true&seo=true&playerPreference%5Bquality%5D=1080p`}
        width="100%"
        height="100%"
        title={title}
        allow="autoplay; fullscreen"
        className="wistia_embed"
        name="wistia_embed"
      />
    </div>
  )
}
